import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useReveal from '@/hooks/useReveal';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Catalog from './components/Catalog';
import Featured from './components/Featured';
import Supply from './components/Supply';
import Industries from './components/Industries';
import Quality from './components/Quality';
import QuoteForm from './components/QuoteForm';

export default function Home() {
  useReveal();
  const { hash, key } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    let raf = 0;
    const go = () => {
      raf = requestAnimationFrame(() => requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ block: 'start' });
      }));
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
    return () => { cancelAnimationFrame(raf); window.removeEventListener('load', go); };
  }, [hash, key]);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <Catalog />
        <Featured />
        <Supply />
        <Industries />
        <Quality />
        <QuoteForm />
      </main>
      <Footer />
    </>
  );
}